import { Box, Stack, Typography, styled } from "@mui/material";

export const CardRoot = styled(Stack)<{ bordercolor: string }>(({ theme, bordercolor }) => ({
  position: "relative",
  alignItems: "center",
  background: theme.customColors.backgroundCard,
  borderLeft: `3px solid ${bordercolor}`,
  flexDirection: "row",
  gap: "12px",
  padding: "12px 16px",
  width: "100%",

  "&:hover": {
    background: theme.customColors.backgroundSecondaryHover
  },

  "&:focus-visible": {
    outline: `2px solid ${theme.customColors.accentVariantA}`,
    outlineOffset: "2px"
  }
}));

export const CardContent = styled(Box)(() => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: "8px",
  minWidth: 0
}));

export const StatusRow = styled(Stack)(() => ({
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%"
}));

export const StatusLabel = styled(Typography)<{ statuscolor: string }>(({ statuscolor }) => ({
  color: statuscolor,
  fontSize: "0.75rem",
  fontWeight: 700,
  letterSpacing: "0.05em",
  lineHeight: "1rem",
  textTransform: "uppercase"
}));

export const TimeText = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  flexShrink: 0,
  fontSize: "0.875rem",
  fontWeight: 500,
  lineHeight: "1.25rem"
}));

export const TitleText = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "1rem",
  fontWeight: 700,
  lineHeight: "1.375rem",
  wordBreak: "break-word"
}));

export const SubtitleText = styled(Typography)(({ theme }) => ({
  color: theme.customColors.exploreCardText,
  fontSize: "0.75rem",
  fontWeight: 400,
  lineHeight: "1rem"
}));

export const ChevronWrapper = styled(Box)(({ theme }) => ({
  alignItems: "center",
  color: theme.customColors.textPrimary,
  cursor: "pointer",
  display: "flex",
  flexShrink: 0,

  "&:focus-visible": {
    outline: `2px solid ${theme.customColors.accentVariantA}`,
    outlineOffset: "2px",
    borderRadius: "2px"
  }
}));

export const ActionIconWrapper = styled(Box)<{ iconbgcolor: string }>(({ iconbgcolor }) => ({
  position: "absolute",
  right: "50px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: "28px",
  height: "28px",
  borderRadius: "4px",
  backgroundColor: iconbgcolor
}));

export const LiveEventInfoRow = styled(Typography)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "24px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "start",
    gap: "12px"
  }
}));
